import React, { useEffect, useState } from "react"
import Button from "aldoo-ra/Button"
import Typography from "aldoo-ra/Typography"
import PlatformAuth from "aldoo-ra/PlatformAuth"
import { navigate } from "vike/client/router"
import PubSub from "pubsub-js"
import Navbar from "@components/Navbar"

const HomePage = () => {
  const [auth] = PlatformAuth.useAuth()
  const [mounted, setMounted] = useState(false)
  useEffect(() => setMounted(true), [])

  const onSignin = () => PubSub.publish("signin", { redirect: "/account" })
  const onAccount = () => navigate("/account")

  return (
    <div className="min-h-screen bg-paper">
      <Navbar />
      <div className="min-h-screen flex flex-col items-center justify-center p-8 pt-24">
        <div className="max-w-xl text-center space-y-6">
          <Typography variant="admin_h1">Aldoo Status</Typography>
          <Typography variant="admin_body">
            Monitor your software components. Track uptime, latency, screenshots, and incidents.
          </Typography>
          <div className="flex gap-3 justify-center">
            {mounted && auth
              ? <Button onClick={onAccount}>Go to account</Button>
              : <Button onClick={onSignin}>Sign in</Button>}
          </div>
        </div>
      </div>
    </div>
  )
}

export default HomePage
